export enum TreasureChestInfo {
  TREASURE_CHEST_NAME = '[TC]',
}
